export const quemSomosEPilaresContent = {
  quemSomos: {
    heading: "QUEM SOMOS",
    body:
      "O Pastejo foi construído a partir da experiência prática de quem conhece a pecuária por dentro e entende que o resultado, dentro da porteira, depende de controle, execução e disciplina.",
  },
  nossosPilares: {
    sectionTitle: "NOSSOS PILARES",
    pillars: [
      {
        title: "Estoque de Gado",
        description: "Mais precisão no controle de lotes, quantidades e movimentações.",
      },
      {
        title: "Manejo de Pasto",
        description:
          "Mais eficiência no uso das áreas, sejam elas manejadas por altura, tempo de ocupação ou escore de pasto.",
      },
      {
        title: "Suplementação",
        description: "Mais controle sobre frequência, consumo e execução do planejamento nutricional.",
      },
    ],
  },
} as const;
